import { render, staticRenderFns } from "./InfoUpdate.vue?vue&type=template&id=71eab557&"
import script from "./InfoUpdate.vue?vue&type=script&lang=js&"
export * from "./InfoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports